import React from "react";

// Inline SVG WhatsApp icon (brand-accurate)
export function WhatsAppIcon({ size = 20, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.03 21.5h-.005a9.87 9.87 0 0 1-5.03-1.378l-.361-.214-3.741.982.999-3.648-.235-.375A9.86 9.86 0 0 1 2.14 12C2.14 6.586 6.62 2.184 12.038 2.184c2.641 0 5.121 1.03 6.988 2.898a9.825 9.825 0 0 1 2.895 6.988c-.003 5.414-4.483 9.43-9.891 9.43zm8.413-18.416A11.815 11.815 0 0 0 12.037 0C5.495 0 .174 5.334.171 11.884c0 2.096.548 4.142 1.588 5.945L0 24l6.335-1.652a11.882 11.882 0 0 0 5.687 1.448h.005c6.542 0 11.865-5.334 11.867-11.884a11.83 11.83 0 0 0-3.451-8.428z" />
    </svg>
  );
}
